import { render, staticRenderFns } from "./moderatorCard.vue?vue&type=template&id=409ef27a&scoped=true&"
import script from "./moderatorCard.vue?vue&type=script&lang=js&"
export * from "./moderatorCard.vue?vue&type=script&lang=js&"
import style0 from "./moderatorCard.vue?vue&type=style&index=0&id=409ef27a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409ef27a",
  null
  
)

export default component.exports